/**
 * Query string da localização → objeto plano. O validador do calendário
 * (em `router.tsx`) transforma isso no search tipado da rota.
 */
export function parseSearchParamsRecord(searchStr: string): Record<string, string> {
  const raw = searchStr.startsWith("?") ? searchStr.slice(1) : searchStr;
  return Object.fromEntries(new URLSearchParams(raw).entries());
}

/**
 * Junta o recorte atual da URL com um patch, sem reaplicar a view padrão das
 * preferências. Sem isso, clicar num cliente (ou no mini-mês) apaga `view=semana`.
 */
export function mergeCalendarSearch<T extends object>(current: T, patch: Partial<T>): T {
  return { ...current, ...patch };
}
